module.exports = __webpack_public_path__ + "img/ayun-inventory.90103dc2.svg";